import styled from '@emotion/styled/macro';

import FormValueInfo from '../FormValueInfo/FormValueInfo';

export const StyledFormValueInfo = styled(FormValueInfo)`
  width: 1.75rem;
`;
